/* PM calculator 'Explore more' category strip. Markup comes from the pm-calc-grid section (home page category tile design).
   Moves under the product grid, stays hidden until a result exists, orders tiles by calculator and result, keeps UTMs, tracks clicks. */
(function(){
  if(window.PMCalcCats) return;
  window.dataLayer=window.dataLayer||[];
  var ORDER={
    moolank:['bracelets','malas','rudraksha','kirtimukh','idols','vatika'],
    rashi:['bracelets','rudraksha','malas','kirtimukh','idols','vatika'],
    shani:{'clear':['bracelets','rudraksha','malas','kirtimukh','idols','vatika'],'*':['malas','rudraksha','bracelets','kirtimukh','idols','vatika']},
    devta:{'shiva':['rudraksha','malas','idols','bracelets','kirtimukh','vatika'],'vishnu':['idols','vatika','malas','bracelets','rudraksha','kirtimukh'],'lakshmi':['idols','vatika','bracelets','malas','rudraksha','kirtimukh'],'*':['idols','malas','rudraksha','bracelets','kirtimukh','vatika']}
  };
  function pick(calc,key){
    var o=ORDER[calc]; if(!o) return ORDER.rashi;
    if(Array.isArray(o)) return o;
    var k=String(key||'').split(',')[0];
    return o[k]||o['*'];
  }
  function utmKeep(root){
    if(!location.search) return;
    var sp;try{sp=new URLSearchParams(location.search);}catch(e){return;}
    ['moolank','rashi','devta','shani','section_id','sort_by'].forEach(function(k){sp.delete(k);});
    if(!Array.from(sp.keys()).length) return;
    [].forEach.call(root.querySelectorAll('a[href]'),function(a){
      var h=a.getAttribute('href'); if(!h||h.charAt(0)!=='/'||h.indexOf('//')===0) return;
      try{var u=new URL(h,location.origin);sp.forEach(function(v,k){if(!u.searchParams.has(k))u.searchParams.set(k,v);});a.setAttribute('href',u.pathname+u.search+u.hash);}catch(e){}
    });
  }
  function order(strip,calc,key){
    var ul=strip.querySelector('ul'); if(!ul) return;
    var want=pick(calc,key), sig=calc+'|'+want.join(',');
    if(strip.getAttribute('data-ord')===sig) return;
    var items={};[].forEach.call(ul.children,function(li){items[li.getAttribute('data-cat')]=li;});
    want.forEach(function(c){ if(items[c]) ul.appendChild(items[c]); });
    [].forEach.call(ul.children,function(li,i){li.id=li.id.replace(/-\d+$/,'')+'-'+(i+1);});
    strip.setAttribute('data-ord',sig);
    ul.scrollLeft=0;
  }
  function init(){
    var strips=[].slice.call(document.querySelectorAll('[data-pmcats]'));
    var mounts=[].slice.call(document.querySelectorAll('[data-pmcg]'));
    if(!strips.length||!mounts.length) return;
    /* one strip per page, tied to the last grid (quiz: after the second result) */
    var mount=mounts[mounts.length-1], strip=null;
    strips.forEach(function(s){ if(s.closest('.shopify-section')===mount.closest('.shopify-section')&&!strip) strip=s; else if(s.parentNode) s.parentNode.removeChild(s); });
    if(!strip) return;
    var w=mount.closest('.shopify-section')||mount;
    if(w.parentNode) w.parentNode.insertBefore(strip,w.nextSibling);
    var calc=mount.getAttribute('data-calc-page');
    function sync(){
      var on=!mount.hidden&&mount.getAttribute('data-calc-key');
      if(on){ order(strip,calc,mount.getAttribute('data-calc-key')); utmKeep(strip); }
      strip.hidden=!on;
    }
    new MutationObserver(sync).observe(mount,{attributes:true,attributeFilter:['hidden','data-calc-key']});
    strip.addEventListener('click',function(e){
      var a=e.target.closest&&e.target.closest('a[href]'); if(!a) return;
      var li=a.closest('[data-cat]');
      window.dataLayer.push({event:'calc_category_click',calc:calc,key:mount.getAttribute('data-calc-key')||'',category:li?li.getAttribute('data-cat'):''});
    });
    sync();
  }
  window.PMCalcCats={init:init};
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
})();
